import React from 'react';
import Select from 'react-select';

import { FormattedMessage, injectIntl } from 'react-intl';
import MultiSelect from './multiSelect';
import DAY_OF_WEEK from '../constants/dayOfWeek';

class ItemMarketplaces extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showAllMarketplaces: false,
      selectedMarketplaces: this.props.formData,
    };

    this.onMarketplaceDeSelect = this.onMarketplaceDeSelect.bind(this);
    this.onMarketplaceSelect = this.onMarketplaceSelect.bind(this);
    this.getSelectedMarketplaces = this.getSelectedMarketplaces.bind(this);
    this.getNonSelectedMarketplaces = this.getNonSelectedMarketplaces.bind(this);
    this.setShowAllMarketplaces = this.setShowAllMarketplaces.bind(this);
    this.onAvailabilityDaysChange = this.onAvailabilityDaysChange.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      selectedMarketplaces: nextProps.formData,
    });
  }

  onCategoryChange(marketplace, category) {
    const selectedMarketplaces = this.state.selectedMarketplaces;
    const selectedMarketplaceIndex = selectedMarketplaces.findIndex(
      (selectedMarketplace) => selectedMarketplace.marketplaceId === marketplace.id
    );
    if (selectedMarketplaceIndex !== -1) {
      selectedMarketplaces[selectedMarketplaceIndex].category = category;
    }

    this.setState(
      {
        selectedMarketplaces: selectedMarketplaces,
      },
      () => this.props.onChange(this.state.selectedMarketplaces)
    );
  }

  onStockTrigger(marketplace, newValue) {
    const DEFAULT_STOCK = '10';
    const DEFAULT_STOCK_WARNING = '5';

    const newSelectedMarketplaces = this.state.selectedMarketplaces;
    const selectedMarketplaceIndex = newSelectedMarketplaces.findIndex(
      (selectedMarketplace) => selectedMarketplace.marketplaceId === marketplace.id
    );

    if (selectedMarketplaceIndex !== -1) {
      if (newValue) {
        newSelectedMarketplaces[selectedMarketplaceIndex].stock = DEFAULT_STOCK;
        newSelectedMarketplaces[selectedMarketplaceIndex].stockWarning = DEFAULT_STOCK_WARNING;
      } else {
        newSelectedMarketplaces[selectedMarketplaceIndex].stock = null;
        newSelectedMarketplaces[selectedMarketplaceIndex].stockWarning = null;
        newSelectedMarketplaces[selectedMarketplaceIndex].hideWhenOutOfStock = false;
        newSelectedMarketplaces[selectedMarketplaceIndex].stockResetQuantity = null;
      }
    }

    this.setState(
      {
        selectedMarketplaces: newSelectedMarketplaces,
      },
      () => this.props.onChange(this.state.selectedMarketplaces)
    );
  }

  onAvailabilityDaysTrigger(marketplace, newValue) {
    const DEFAULT_VALUE = ['TUESDAY', 'THURSDAY'];

    const newSelectedMarketplaces = [...this.state.selectedMarketplaces];
    const selectedMarketplaceIndex = newSelectedMarketplaces.findIndex(
      (selectedMarketplace) => selectedMarketplace.marketplaceId === marketplace.id
    );

    if (selectedMarketplaceIndex !== -1) {
      if (newValue) {
        newSelectedMarketplaces[selectedMarketplaceIndex].availabilityDays = DEFAULT_VALUE;
      } else {
        newSelectedMarketplaces[selectedMarketplaceIndex].availabilityDays = [];
      }
    }

    this.setState(
      {
        selectedMarketplaces: newSelectedMarketplaces,
      },
      () => this.props.onChange(this.state.selectedMarketplaces)
    );
  }

  onMarketplaceSelect(marketplace) {
    const marketplaces = this.state.selectedMarketplaces;
    const selectedMarketplaceIndex = marketplaces.findIndex(
      (selectedMarketplace) => selectedMarketplace.marketplaceId === marketplace.id
    );

    if (selectedMarketplaceIndex === -1) {
      marketplaces.push({
        marketplaceId: marketplace.id,
        stock: null,
        stockWarning: null,
        hideWhenOutOfStock: false,
        stockResetQuantity: null,
        availabilityDays: [],
        packingSection: '',
      });
    }

    this.setState(
      {
        selectedMarketplaces: marketplaces,
      },
      () => this.props.onChange(this.state.selectedMarketplaces)
    );
  }

  onMarketplaceDeSelect(marketplace) {
    if (
      !window.confirm(this.props.intl.formatMessage({ id: 'item.form.field.marketplaces.de.select.button.confirm' }))
    ) {
      return;
    }
    const marketplaces = this.state.selectedMarketplaces;
    const selectedIndex = marketplaces.findIndex(
      (selectedMarketplace) => selectedMarketplace.marketplaceId === marketplace.id
    );

    if (selectedIndex !== -1) {
      marketplaces.splice(selectedIndex, 1);
      this.setState(
        {
          selectedMarketplaces: marketplaces,
        },
        () => this.props.onChange(this.state.selectedMarketplaces)
      );
    }
  }

  onChange(index, fieldName) {
    return (event) => {
      const newSelectedMarketplaces = this.state.selectedMarketplaces;
      newSelectedMarketplaces[index][fieldName] = event.target.value;

      this.setState(
        {
          selectedMarketplaces: newSelectedMarketplaces,
        },
        () => this.props.onChange(this.state.selectedMarketplaces)
      );
    };
  }

  onAvailabilityDaysChange(index, newValue) {
    const newSelectedMarketplaces = [...this.state.selectedMarketplaces];
    newSelectedMarketplaces[index]['availabilityDays'] = newValue;

    this.setState(
      {
        selectedMarketplaces: newSelectedMarketplaces,
      },
      () => this.props.onChange(this.state.selectedMarketplaces)
    );
  }

  getSelectedMarketplaces() {
    const selectedMarketplaces = this.props.schema.marketplaces.filter((marketplace) => {
      return this.state.selectedMarketplaces.some(
        (selectedMarketplace) => selectedMarketplace.marketplaceId === marketplace.id
      );
    });

    return selectedMarketplaces.map((marketplace, index) => {
      const selectedMarketplaceItem = this.state.selectedMarketplaces.find(
        (selectedMarketplace) => selectedMarketplace.marketplaceId === marketplace.id
      );

      const categories = this.getCategoriesSelection(marketplace, selectedMarketplaceItem);

      const showStockProperties =
        selectedMarketplaceItem && (selectedMarketplaceItem.stock || selectedMarketplaceItem.stock === '');

      const showAvailabilityDays =
        selectedMarketplaceItem &&
        selectedMarketplaceItem.availabilityDays &&
        selectedMarketplaceItem.availabilityDays.length;

      const availabilityDayOptions = Object.keys(DAY_OF_WEEK).map((key) => {
        const day = DAY_OF_WEEK[key];
        return {
          value: day,
          label: this.props.intl.formatMessage({ id: `day.of.week.value.${day}` }),
        };
      });

      return (
        <div key={index} className="item-form-marketplace selected m-b-3">
          <p className="m-b-1">{marketplace.name}</p>

          {categories}

          <div className="row">
            <div className="col-12">
              <div className="form-group">
                <div className="checkbox">
                  <label>
                    <input
                      type="checkbox"
                      checked={showStockProperties}
                      onChange={() => this.onStockTrigger(marketplace, !showStockProperties)}
                    />{' '}
                    <FormattedMessage id={'item.form.field.marketplaces.show.stock.label'} />
                  </label>
                </div>
                <p className="help-block">
                  <FormattedMessage id={'item.form.field.marketplaces.show.stock.help'} />
                </p>
              </div>
            </div>
            {showStockProperties ? (
              <>
                <div className="col-12 col-sm-6">
                  <div className="form-group">
                    <label className="control-label">
                      <FormattedMessage id={'item.form.field.marketplaces.stock.label'} />
                    </label>
                    <input
                      className="form-control"
                      placeholder=""
                      type="text"
                      value={selectedMarketplaceItem.stock}
                      onChange={this.onChange(index, 'stock')}
                    />
                  </div>
                </div>
                <div className="col-12 col-sm-6">
                  <div className="form-group">
                    <label className="control-label">
                      <FormattedMessage id={'item.form.field.marketplaces.stock.warning.label'} />
                    </label>
                    <div className="m-b-1">
                      <input
                        className="form-control"
                        placeholder=""
                        type="text"
                        value={selectedMarketplaceItem.stockWarning}
                        onChange={this.onChange(index, 'stockWarning')}
                      />
                    </div>
                    <p className="help-block">
                      <FormattedMessage id={'item.form.field.marketplaces.stock.warning.help'} />
                    </p>
                  </div>
                </div>
                <div className="col-12 col-sm-6">
                  <div className="form-group">
                    <label className="control-label">
                      <FormattedMessage id={'item.form.field.marketplaces.stock.reset.quantity.label'} />
                    </label>
                    <div className="m-b-1">
                      <input
                        className="form-control"
                        placeholder=""
                        type="text"
                        value={selectedMarketplaceItem.stockResetQuantity}
                        onChange={this.onChange(index, 'stockResetQuantity')}
                      />
                    </div>
                    <p className="help-block">
                      <FormattedMessage id={'item.form.field.marketplaces.stock.reset.quantity.help'} />
                    </p>
                  </div>
                </div>
              </>
            ) : (
              ''
            )}

            {this.props.schema.showAdminFields ? (
              <div className="col-12 col-sm-6">
                <div className="form-group">
                  <label className="control-label">
                    <FormattedMessage id={'item.form.field.marketplaces.packing.section.label'} />
                  </label>
                  <input
                    className="form-control"
                    placeholder=""
                    type="text"
                    value={selectedMarketplaceItem.packingSection}
                    onChange={this.onChange(index, 'packingSection')}
                  />
                </div>
              </div>
            ) : (
              ''
            )}

            <div className="col-12 d-none">
              <div className="form-group">
                <div className="checkbox">
                  <label>
                    <input
                      type="checkbox"
                      checked={showAvailabilityDays}
                      onChange={() => this.onAvailabilityDaysTrigger(marketplace, !showAvailabilityDays)}
                    />{' '}
                    <FormattedMessage id={'item.form.field.marketplaces.set.availability.days.label'} />
                  </label>
                </div>
                <p className="help-block">
                  <FormattedMessage id={'item.form.field.marketplaces.set.availability.days.help'} />
                </p>
              </div>
            </div>

            {showAvailabilityDays ? (
              <div className="col-12">
                <div className="form-group">
                  <MultiSelect
                    schema={{
                      title: this.props.intl.formatMessage({
                        id: 'item.form.field.marketplaces.availability.days.label',
                      }),
                      options: availabilityDayOptions,
                    }}
                    onChange={(value) => this.onAvailabilityDaysChange(index, value)}
                    formData={selectedMarketplaceItem.availabilityDays}
                  />
                </div>
              </div>
            ) : (
              ''
            )}
          </div>
          <button className="btn btn-default btn-small" onClick={() => this.onMarketplaceDeSelect(marketplace)}>
            <FormattedMessage id={'item.form.field.marketplaces.de.select.button.label'} />
          </button>
        </div>
      );
    });
  }

  getNonSelectedMarketplaces() {
    if (!this.state.showAllMarketplaces) {
      return '';
    }

    const nonSelectedMarketplaces = this.props.schema.marketplaces.filter((marketplace) => {
      return !this.state.selectedMarketplaces.some(
        (selectedMarketplace) => selectedMarketplace.marketplaceId === marketplace.id
      );
    });

    return nonSelectedMarketplaces.map((marketplace, index) => {
      return (
        <div key={index} className="item-form-marketplace m-b-3">
          <p className="m-b-1">{marketplace.name}</p>

          <button className="btn btn-default btn-small" onClick={() => this.onMarketplaceSelect(marketplace)}>
            <FormattedMessage id={'item.form.field.marketplaces.select.button.label'} />
          </button>
        </div>
      );
    });
  }

  getCategoriesSelection(marketplace, selectedMarketplace) {
    if (!marketplace.categories || !marketplace.categories.length) {
      return '';
    }

    const options = marketplace.categories.map((category) => {
      return {
        label: category,
        value: category,
      };
    });

    const selectedCategory = selectedMarketplace ? selectedMarketplace.category : null;

    const value = selectedCategory ? options.find((option) => option.value === selectedCategory) : null;

    return (
      <div className="m-b-3">
        <Select
          name="form-field-name"
          placeholder="Select category..."
          value={value}
          options={options}
          onChange={(category) => this.onCategoryChange(marketplace, category.value)}
        />
      </div>
    );
  }

  setShowAllMarketplaces(newValue) {
    this.setState({
      showAllMarketplaces: newValue,
    });
  }

  render() {
    const selectedMarketplaces = this.getSelectedMarketplaces();
    const nonSelectedMarketplaces = this.getNonSelectedMarketplaces();

    return (
      <div>
        <legend className="control-label">{this.props.schema.title}</legend>
        {selectedMarketplaces}
        {nonSelectedMarketplaces}

        {this.state.showAllMarketplaces ? (
          <div className="item-form-marketplace__trigger m-b-2" onClick={() => this.setShowAllMarketplaces(false)}>
            <small>
              <i className="fa fa-minus-circle" />{' '}
              <FormattedMessage id={'item.form.field.marketplaces.trigger.hide.non.selected'} />
            </small>
          </div>
        ) : (
          <div className="item-form-marketplace__trigger m-b-2" onClick={() => this.setShowAllMarketplaces(true)}>
            <small>
              <i className="fa fa-plus-circle" />{' '}
              <FormattedMessage id={'item.form.field.marketplaces.trigger.show.other.marketplaces'} />
            </small>
          </div>
        )}
      </div>
    );
  }
}

export default injectIntl(ItemMarketplaces);
